module.exports = __webpack_public_path__ + "img/successpurple.4c60b975.png";